// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ServiceRow/index.css
// module id = 2272
// module chunks = 0